import { render } from "./ActivosRegistro.vue?vue&type=template&id=53cebd38"
import script from "./ActivosRegistro.vue?vue&type=script&lang=js"
export * from "./ActivosRegistro.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__